import { ref } from 'vue';

const isActive = ref(false);
const activeIcon = ref<string | null>(null);
const activeEmoji = ref<string | null>(null);
const activeLabel = ref<string | null>(null);
let timeout: ReturnType<typeof setTimeout> | null = null;

const CONFETTI_DURATION_MS = 3000;

export function useConfetti() {
  const fire = (options?: { icon?: string; emoji?: string; label?: string }) => {
    if (timeout) clearTimeout(timeout);
    activeIcon.value = options?.icon ?? null;
    activeEmoji.value = options?.emoji ?? null;
    activeLabel.value = options?.label ?? null;
    isActive.value = true;
    timeout = setTimeout(() => {
      isActive.value = false;
      activeIcon.value = null;
      activeEmoji.value = null;
      activeLabel.value = null;
      timeout = null;
    }, CONFETTI_DURATION_MS);
  };

  return { isActive, activeIcon, activeEmoji, activeLabel, fire };
}
